import Selection from '../../../../../../core-lib/js/Selection/Selection';
import Ajax from '../core/Ajax';
import BackgroundImage from '../library/BackgroundImage';

export default class Swimlane {

	constructor(el) {
		this.el = el;
		this.layout = this.el.dataset.layout;
		this.itemStyle = this.el.dataset.itemStyle;
		this.method = this.el.dataset.method;
		this.categories = this.el.dataset.categories;
		this.keyword = this.el.dataset.keyword;
		this.createHero = this.el.dataset.createHero;
		this.list = this.el.querySelector('.swimlane__list');
		this.ad = this.list.querySelectorAll('.swimlane__item--ad');

		this.onClickMore = this.onClickMore.bind(this);
		this.onResize = this.onResize.bind(this);
		this.onAdsLoaded = this.onAdsLoaded.bind(this);

		this.positionHero();
		this.positionAd();
		this.initMasonry();
		this.initMoreButton();

		window.addEventListener('resize', this.onResize);
		window.addEventListener('adsloaded', this.onAdsLoaded);
		window.addEventListener('DOMContentLoaded', () => {
			setTimeout(() => {
				this.initMasonry();
			}, 500);
		});
	}

	positionHero() {
		if (this.createHero) {
			const hero = this.el.nextElementSibling;

			if (hero && hero.classList.contains('hero')) {
				this.el.parentElement.insertBefore(hero, this.el.parentElement.firstChild);
			}
		}
	}

	positionAd() {
		for (let ad of this.ad) {
			const items = this.list.querySelectorAll('.swimlane__item');
			const position = ad.dataset.position;
			const size = ad.dataset.size;
			const nextItem = this.list.querySelector(`.swimlane__item:nth-child(${position})`);

			for (let item of items) {
				item.classList.remove('swimlane__item--margin-right');
				item.classList.remove('swimlane__item--margin-left');
			}

			if (nextItem && !ad.vbPositioned) {
				this.list.insertBefore(ad, nextItem);
				ad.vbPositioned = true;
			}

			if (size == 'double') {
				let placeholderPosition = 0;
				let placeholderDirection = 'right';

				if (window.innerWidth >= 1024) {
					if (position % 3 == 1) {
						placeholderPosition = parseInt(position) + 3;
						placeholderDirection = 'left';
					} else {
						placeholderPosition = parseInt(position) + 2;
					}
				} else {
					if (position % 2 == 0) {
						placeholderPosition = parseInt(position) + 1;
					} else {
						placeholderPosition = parseInt(position) + 2;
						placeholderDirection = 'left';
					}
				}

				const placeholder = this.list.querySelector(`.swimlane__item:nth-child(${placeholderPosition})`);

				if (placeholder) {
					placeholder.classList.add(`swimlane__item--margin-${placeholderDirection}`);

					if (window.innerWidth >= 1024) {
						ad.style.marginBottom = `-${placeholder.offsetHeight + 16}px`;
					} else if (window.innerWidth >= 768) {
						ad.style.marginBottom = `-${placeholder.offsetHeight + 16}px`;
					} else {
						ad.style.marginBottom = null;
					}
				}
			}
		}
	}

	initMasonry() {
		if (window.innerWidth >= 768 && this.layout == 'masonry') {
			this.masonry = new Masonry(this.list, {});
		}
	}

	initMoreButton() {
		this.moreButton = this.el.querySelector('.swimlane__more-button');
		if (this.moreButton) {
			this.moreButton.addEventListener('click', this.onClickMore);
		}
	}

	parsePayload(response) {
		const parser = new DOMParser();
		const postsHTML = parser.parseFromString(response.posts, 'text/html');
		const moreButtonHTML = parser.parseFromString(response.moreButton, 'text/html');
		const posts = postsHTML.querySelectorAll('.swimlane__item');
		const moreButton = moreButtonHTML.querySelector('.swimlane__more-button');
		let imagesCount = 0;
		let loadedImages = 0;

		for (let post of posts) {
			this.list.appendChild(post);
			const imageWrapper = post.querySelector('.img2bg');
			const image = post.querySelector('img');

			if (imageWrapper) {
				BackgroundImage(imageWrapper);
			}

			if (image) {
				imagesCount++;
				image.addEventListener('load', () => {
					loadedImages++;
					if (loadedImages == imagesCount) {
						this.initMasonry();
					}
				});
			}
		}

		if (moreButton) {
			this.moreButton.dataset.offset = moreButton.dataset.offset;
			this.moreButton.classList.remove('swimlane__more-button--disabled');
		} else {
			this.moreButton.parentNode.parentNode.removeChild(this.moreButton.parentNode);
		}

		this.initMasonry();

		document.dispatchEvent(vb.itemsLoadedEvent);
	}

	onClickMore(e) {
		this.moreButton.classList.add('swimlane__more-button--disabled');

		new Ajax({
			method: 'GET',
			params: {
				action: 'ajax_load_posts',
				layout: this.layout,
				itemStyle: this.itemStyle,
				method: this.method,
				categories: this.categories,
				keyword: this.keyword,
				number: this.moreButton.dataset.number,
				offset: this.moreButton.dataset.offset,
				buttonLabel: this.moreButton.textContent
			},
			callback: ajax => {
				if (ajax.ok && !ajax.response.error) {
					this.parsePayload(ajax.response);
				} else {
					console.error(ajax.response.error);
				}
			}
		});
	}

	onResize(e) {
		if (window.innerWidth != vb.innerWidth) {
			this.positionAd();
		}

		this.initMasonry();
	}

	onAdsLoaded(e) {
		const iframe = new Selection(`#${e.detail} iframe`, this.el);
		iframe.on('load', this.onResize);
	}

}
